import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Card, CardHeader, CardContent, TextField, Grid } from '@material-ui/core'

import FormControl from '@material-ui/core/FormControl'
import Checkbox from '@material-ui/core/Checkbox'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import AutocompleteNative from '@material-ui/lab/Autocomplete'

import validate from 'validate.js'
import useRouter from 'utils/useRouter'
import { usePermissaoService } from 'hooks/usePermissaoService'
import { useCargoService } from 'hooks/useCargoService'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const useStyles = makeStyles((theme) => ({
  root: {},
  alert: {
    marginBottom: theme.spacing(3),
  },
  formGroup: {
    marginBottom: theme.spacing(3),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  fieldHint: {
    margin: theme.spacing(1, 0),
  },
  tags: {
    marginTop: theme.spacing(1),
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
  },
  flexGrow: {
    flexGrow: 1,
  },
  dateField: {
    '& + &': {
      marginLeft: theme.spacing(2),
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  enviarImagemComputador: {
    display: 'none',
  },
  fotos: {
    margin: theme.spacing(1),
  },
}))

const schema = {
  nome: {
    presence: { allowEmpty: false, message: '^Cargo é obrigatório' },
  },
  sigla: {
    presence: { allowEmpty: false, message: '^Cargo é obrigatório' },
  },
  descricao: {
    presence: { allowEmpty: false, message: '^Cargo é obrigatório' },
  },
}

export const Formulario = (props) => {
  const { className, editar, dados, ...rest } = props
  const cargoService = useCargoService()
  const permissaoService = usePermissaoService()
  const classes = useStyles()
  const dispatch = useDispatch()
  const router = useRouter()

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      permissoes: [],
    },
    touched: {},
    errors: {},
  })

  useEffect(() => {
    if (editar) {
      setFormState((formState) => ({
        ...formState,
        values: {
          ...formState.values,
          nome: dados.nome,
          sigla: dados.sigla,
          descricao: dados.descricao,
          permissoes: dados.permissoes,
        },
      }))
    }
   
  }, [dados, editar])

  useEffect(() => {
    const errors = validate(formState.values, schema)

    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }))
    
  }, [formState.values])

  const verificaChecked = (id) => {
    if (formState.values.permissoes.indexOf(id) !== -1) {
      return true
    }
    return false
  }

  const removerCheck = (event) => {
    formState.values.permissoes.splice(formState.values.permissoes.indexOf(event.target.value), 1)
    setFormState({ ...formState })
  }

  const adicionarCheck = (event) => {
    formState.values.permissoes.push(event.target.value)
    setFormState({ ...formState })
  }

  const handleChange = (event) => {
    event.persist()
    if (event.target.type === 'checkbox' && verificaChecked(event.target.value)) removerCheck(event)
    else if (event.target.type === 'checkbox') adicionarCheck(event)
    else
      setFormState((formState) => ({
        ...formState,
        values: {
          ...formState.values,
          [event.target.name]:
            event.target.type === 'checkbox' ? event.target.value : event.target.value,
        },
        touched: {
          ...formState.touched,
          [event.target.name]: true,
        },
      }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (formState.isValid) {
      if (editar) {
        await cargoService.editarCargo(dados.id, formState.values)
      } else {
        await cargoService.cadastrarCargo(formState.values)
      }
      router.history.push('/cargos')
    }
  }

  const getPermissoesSelecionadas = (permissoes) => {
    const selecao = []
    if (permissoes) {
      permissoes.every(async (permissao) => {
        if (formState.values.permissoes && formState.values.permissoes.indexOf(permissao.id) >= 0) {
          selecao.push(permissao)
        }
      })
      return selecao
    }
    return null
  }

  const handleChangePermissao = (event, newValue) => {
    const set = []
    newValue.map(async (permissao) => {
      set.push(permissao.id)
    })
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        permissoes: set,
      },
      touched: {
        ...formState.touched,
        permissoes: true,
      },
    }))
  }

  const hasError = (field) => !!(formState.touched[field] && formState.errors[field])

  /**
   * @description Obtem a lista de permissões do sistema
   */
  const [cargoPermissoes, setCargoPermissoes] = useState([])
  useEffect(() => {
    const fetchDados = async () => {
      const permissoes = await permissaoService.listarPermissoesAsync()
      if (permissoes) {
        setCargoPermissoes(permissoes)
      }
    }
    fetchDados()
   
  }, [dispatch, router])

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <form
          id="form-cargo"
          onSubmit={handleSubmit}
          {...rest}
          className={clsx(classes.root, className)}
        >
          <Grid
            className={classes.fieldGroup}
            alignItems="center"
            container
            justify="space-between"
          >
            <Grid className={classes.item} item md={8} sm={8} xs={12}>
              <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
                <TextField
                  error={hasError('nome')}
                  fullWidth
                  helperText={hasError('nome') ? formState.errors.nome[0] : null}
                  label="Nome do cargo"
                  name="nome"
                  onChange={handleChange}
                  value={formState.values.nome || ''}
                  required
                />
              </FormControl>
            </Grid>
            <Grid className={classes.item} item md={3} sm={3} xs={12}>
              <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
                <TextField
                  error={hasError('sigla')}
                  fullWidth
                  helperText={hasError('sigla') ? formState.errors.sigla[0] : null}
                  label="Sigla"
                  name="sigla"
                  onChange={handleChange}
                  value={formState.values.sigla || ''}
                  required
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid
            className={classes.fieldGroup}
            alignItems="center"
            container
            justify="space-between"
          >
            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
                <TextField
                  error={hasError('descricao')}
                  fullWidth
                  helperText={hasError('descricao') ? formState.errors.descricao[0] : null}
                  label="Descrição"
                  multiline
                  rows={2}
                  name="descricao"
                  onChange={handleChange}
                  value={formState.values.descricao || ''}
                  required
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid
            className={classes.fieldGroup}
            alignItems="center"
            container
            justify="space-between"
          >
            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <FormControl
                style={{
                  minWidth: '100%',
                  maxWidth: '100%',
                }}
              >
                <AutocompleteNative
                  value={getPermissoesSelecionadas(cargoPermissoes)}
                  multiple
                  name="setoresInteressados"
                  noOptionsText="Sem informações"
                  options={cargoPermissoes}
                  disableCloseOnSelect
                  onChange={(event, newValue) => {
                    handleChangePermissao(event, newValue)
                  }}
                  getOptionLabel={(option) => option.nome}
                  renderOption={(option, { selected }) => (
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{
                          marginRight: 8,
                        }}
                        checked={selected}
                      />
                      {option.nome}
                    </>
                  )}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" label="Permissões" />
                  )}
                />
              </FormControl>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  )
}
